import React from 'react';
import EmptyProducts from '../EmptyProducts';
import * as Styles from './ProductList.style';
import { Button } from 'gatorcomponents';
import useLocale from '@/hooks/useLocale';
import ProductItem from '../ProductItem';
import { useHistory } from 'react-router';
import { locale } from '@/utils/locale';
import { homeAnalytics } from '@/analytics/home';

const ProductList = ({
  variant, itens, testId, size,
}) => {
  const { home: homeLocale } = useLocale();
  const history = useHistory();

  const getTexts = () => {
    switch (variant) {
      case 'hosting':
        return {
          title: homeLocale.ContractedProducts.hosting.title,
          buttonGoToLabel: homeLocale.ContractedProducts.hosting.buttonGoToLabel,
          emptyTitle: homeLocale.ContractedProducts.hosting.empty.title,
          emptySubtitle: homeLocale.ContractedProducts.hosting.empty.subtitle,
          emptyButtonLabel: homeLocale.ContractedProducts.hosting.empty.buttonLabel,
        };
      case 'domain':
        return {
          title: homeLocale.ContractedProducts.domain.title,
          buttonGoToLabel: homeLocale.ContractedProducts.domain.buttonGoToLabel,
          emptyTitle: homeLocale.ContractedProducts.domain.empty.title,
          emptySubtitle: homeLocale.ContractedProducts.domain.empty.subtitle,
          emptyButtonLabel: homeLocale.ContractedProducts.domain.empty.buttonLabel,
        };
      default:
        return {
          title: '',
          buttonGoToLabel: '',
          emptyTitle: '',
          emptySubtitle: '',
          emptyButtonLabel: '',
        };
    }
  };

  const urlHosting = locale('routes.products');
  const urlDomain = locale('routes.domains');

  const getButtonAction = (variant) => {
    switch (variant) {
      case 'hosting':
        homeAnalytics.contractedHostingsGoToClick();
        return (history.push(urlHosting));
      case 'domain':
        homeAnalytics.contractedDomainsGoToClick();
        return (history.push(urlDomain));
      default:
        return null;
    }
  };

  const texts = getTexts();
  const listItens = itens || [];
  const listItensLength = Object.keys(listItens).length;

  return (
    <>
      {listItensLength > 0 ? (
        <>
          <Styles.WrapperProductList data-testid={testId}>
            <Styles.Title>
              {texts.title}
            </Styles.Title>

            <Styles.ProductList>
              {listItens.slice(0, 2).map(item => (
                <ProductItem
                  variant={variant}
                  product={item}
                  key={item.id}
                />
              ))}

              <Styles.Row>
                <Button
                  label={texts.buttonGoToLabel}
                  onClick={() => getButtonAction(variant)}
                  size="medium"
                  testId="button"
                  title={texts.buttonGoToLabel}
                  type="button"
                  variant="tertiary"
                  version="v2"
                  width="fit-content"
                />
              </Styles.Row>
            </Styles.ProductList>
          </Styles.WrapperProductList>
        </>
      ) : (
        <EmptyProducts
          variant={variant}
          title={texts.emptyTitle}
          subtitle={texts.emptySubtitle}
          buttonLabel={texts.emptyButtonLabel}
          width={size}
        />
      )}
    </>
  );
};

export default ProductList;
